// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';

new Swiper('.mySwiper', {
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    effect: 'fade',
    speed: 800,
});
(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });

    jQuery(document.body).on('added_to_cart', function (e, fragments, cart_hash, $button) {
        $button.addClass('d-none');
        setTimeout(function () {
            jQuery('.added_to_cart').addClass('btn btn-primary added')
        }, 100);
    });
    // document.addEventListener('added_to_cart', function(e, fragments, cart_hash, $button) {
    //     $button.classList.add('d-none');
    //     setTimeout(function() {
    //         document.querySelectorAll('.added_to_cart').forEach(function (param) {
    //           param.classList.add('btn btn-primary added')
    //         })
    //     }, 100);
    // })
    let roadBtn=document.getElementById('roadmap-btn');
    document.querySelectorAll('[name="learning-roadmap"]').forEach(function (road) {
        road.addEventListener('change', function (e) {
            roadBtn.href=e.target.dataset.url;
        })
    })

    document.addEventListener('click', function (e) {

        const btnAddToCart = e.target.closest('.custom-add-to-cart');
        if (!btnAddToCart) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        if (btnAddToCart.classList.contains('added')) {
            window.location.href = btnAddToCart.getAttribute('href');
            return;
        }

        if (btnAddToCart.dataset.loading === '1') return;
        btnAddToCart.dataset.loading = '1';

        fetch(solicoAjax.ajaxurl, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: new URLSearchParams({
                action: 'custom_add_to_cart',
                product_id: btnAddToCart.dataset.productId
            })
        })
            .then(r => r.json())
            .then(res => {

                btnAddToCart.dataset.loading = '0';

                if (!res.success) return;

                btnAddToCart.classList.add('added', 'wc-forward');
                btnAddToCart.textContent = 'مشاهده سبد خرید';
                btnAddToCart.setAttribute('href', res.data.cart_url);
                btnAddToCart.removeAttribute('data-product-id');

                // فایر دستی ایونت ووکامرس (اختیاری)
                // document.body.dispatchEvent(
                //     new CustomEvent('added_to_cart', {
                //         detail: [res.data.fragments || null, res.data.cart_hash || null, null, btnAddToCart]
                //     })
                // );
            });

    });
    document.querySelectorAll('.like-button').forEach(item => {
        item.addEventListener('click', function (e) {
            const btnLike = e.target.closest('.like-button');
            console.log(btnLike)
            e.preventDefault();

            if (btnLike.dataset.loading === '1') return;
            btnLike.dataset.loading = '1';

            fetch(solicoAjax.ajaxurl, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: new URLSearchParams({
                    action: 'toggle_product_like',
                    product_id: btnLike.dataset.productId
                })
            })
                .then(res => res.json())
                .then(res => {

                    btnLike.dataset.loading = '0';

                    if (!res.success) {
                        alert(res.data?.message || 'خطا');
                        return;
                    }

                    btnLike.classList.toggle('liked', res.data.liked);
                    btnLike.querySelector('span').textContent =
                        res.data.liked ? 'علاقه‌منده' : 'افزودن به علاقه‌مندی';
                });

        })
    })

    // Yoast FAQ block → accordion
    document.querySelectorAll('.wp-block-yoast-faq-block .schema-faq-section, .schema-faq .schema-faq-section').forEach(function (section) {
        var question = section.querySelector('.schema-faq-question');
        var answer = section.querySelector('.schema-faq-answer');
        if (!question || !answer) return;

        question.setAttribute('role', 'button');
        question.setAttribute('tabindex', '0');
        question.setAttribute('aria-expanded', 'false');

        var toggle = function () {
            var isOpen = section.classList.contains('is-open');
            section.classList.toggle('is-open', !isOpen);
            answer.classList.toggle('is-open', !isOpen);
            question.setAttribute('aria-expanded', String(!isOpen));
        };

        question.addEventListener('click', toggle);
        question.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
            }
        });
    });

})();
